export default "__VITE_ASSET__0ee22bac__"